import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button, Popconfirm } from "antd";
import { MyIcon } from "../../common/baseConfig";
import NoneData from "../common/NoneData";
import moment from "moment";
export class ExerRecordPaperCollect extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    curPage: 1,
  }
  componentDidMount() {
    this.onLoadPaperCollect();
  }
  onLoadPaperCollect() {
    this.props.actions.fetchGetCollectionExamList({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
    })
  }
  cancelCollection(ID) {
    this.props.actions.fetchAddCollecton({
      BusID: ID,
      BusType: 1
    }).then(res => {
      if (res.SuccessResponse) {
        this.onLoadPaperCollect();
      }
    })
  }
  renderItem(item, key) {
    return (
      <div key={key} className="paper-collect-item">
        <h1>
          <p>
            <span>【{item.ExamPaperType === 0 ? "模拟试卷" : "历年真题"}】</span>
            <span>{item.Title}</span>
          </p>
          <p>
            {item.DoCount}人做过 {moment(new Date(item.AddTime)).format("YYYY-MM-DD")}
          </p>
        </h1>
        <div className="btns">
          {/* <Button type="theme2" className="btn">查看</Button> */}
          <Button type="theme" className="btn" onClick={() => {
            // this.props.history.push(`/exer/exam/detail/${item.ID}`);
            this.props.history.push(`/ques/prepare/${item.ID}`);
          }}>做题</Button>
          <Popconfirm
            placement="top"
            title={"是否删除该试卷收藏"}
            onConfirm={this.cancelCollection.bind(this, item.ID)}
            okText="确认"
            cancelText="取消"
          >
            <p className="del"><MyIcon type="iconshanchu1" /></p>
          </Popconfirm>
        </div>
      </div>
    )
  }
  render() {
    let {
      fetchGetCollectionExamListPending,
      fetchGetCollectionExamListSuccess,
      fetchGetCollectionExamListTotal, } = this.props.center;
    return (
      <div className="center-exer-record-paper-collect">
        {
          fetchGetCollectionExamListSuccess && fetchGetCollectionExamListSuccess.length > 0 &&
          <div className="paper-collect-list">
            <List
              itemLayout="horizontal"
              size="large"
              pagination={{
                onChange: page => {
                  this.setState({
                    curPage: page,
                  }, () => {
                    this.onLoadPaperCollect();
                  })
                },
                current: this.state.curPage,
                total: fetchGetCollectionExamListTotal,
                pageSize: 5,
              }}
              loading={fetchGetCollectionExamListPending}
              dataSource={fetchGetCollectionExamListSuccess}
              renderItem={(item, key) => this.renderItem(item, key)}
            />
          </div>
        }
        {
          fetchGetCollectionExamListSuccess && fetchGetCollectionExamListSuccess.length === 0 &&
          <div className="noneData">
            <NoneData type={2} />
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordPaperCollect);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordPaperCollect.js